import LinearProgress from "@material-ui/core/LinearProgress";
import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import Divider from "@material-ui/core/Divider";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {Calendar} from "primereact/calendar";
import {ALPHANUM_SPACE, CALENDAR_ES} from "../../../../utils/constants/Constants"
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const Sign = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={9}>
                        <TitlePage
                            title={'Mantenimiento \\ Instituciones \\ ' + props.actionScreen + ' \\ Agregar Firmas'}/>
                    </Grid>
                    <Grid item xs={3}>
                        <div style={{textAlign: 'right'}}>
                            <Button label="Cancelar"
                                    className="p-button-secondary"
                                    onClick={props.handleReturnButton}/>
                            &nbsp;
                            <Button label="Guardar"
                                    onClick={props.pushDataSigns}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div className="p-grid">
                                <div className="p-col-3">
                                    <SubtitleLabel header="Apellido Paterno" isBold={true}/>
                                    <InputText name="aPaterno"
                                               placeholder={"Ex: Smith"}
                                               keyfilter={ALPHANUM_SPACE}
                                               maxLength={15}
                                               value={props.dialogSign.aPaterno}
                                               onChange={props.saveDialogSign}/>
                                </div>
                                <div className="p-col-3">
                                    <SubtitleLabel header="Apellido Materno" isBold={true}/>
                                    <InputText name="aMaterno"
                                               placeholder={"Ex: Hans"}
                                               keyfilter={ALPHANUM_SPACE}
                                               maxLength={15}
                                               value={props.dialogSign.aMaterno}
                                               onChange={props.saveDialogSign}/>
                                </div>
                                <div className="p-col-3">
                                    <SubtitleLabel header="Nombre (s)" isBold={true}/>
                                    <InputText name="name"
                                               placeholder={"Ex: Jonh"}
                                               keyfilter={ALPHANUM_SPACE}
                                               maxLength={15}
                                               value={props.dialogSign.name}
                                               onChange={props.saveDialogSign}/>
                                </div>
                                <div className="p-col-3" />
                                <div className="p-col-3">
                                    <SubtitleLabel header="Tipo de Firma" isBold={true}/>
                                    <Dropdown
                                        name="catSignType"
                                        filter={true}
                                        filterBy="DescrTipoFirma"
                                        options={props.signType}
                                        optionLabel="DescrTipoFirma"
                                        placeholder="Seleccione..."
                                        onChange={props.saveDialogSign}
                                        value={props.dialogSign.catSignType}/>
                                </div>
                                <div className="p-col-3">
                                    <SubtitleLabel header="Identificación" isBold={true}/>
                                    <Dropdown
                                        name="catIdType"
                                        filter={true}
                                        filterBy="DescrIdentificacion"
                                        options={props.idType}
                                        optionLabel="DescrIdentificacion"
                                        placeholder="Seleccione..."
                                        onChange={props.saveDialogSign}
                                        value={props.dialogSign.catIdType}/>
                                </div>
                                <div className="p-col-3">
                                    <SubtitleLabel header="Fecha de Vencimiento" isBold={true}/>
                                    <Calendar
                                        name="fecVencimientoSign"
                                        dateFormat={"dd/mm/yy"}
                                        placeholder={"Ex: 31/12/2020"}
                                        value={props.dialogSign.fecVencimientoSign}
                                        disabledDays={[0, 6]}
                                        readOnlyInput={true}
                                        onChange={props.saveDialogSign}
                                        monthNavigator={true}
                                        yearNavigator={true}
                                        yearRange={CALENDAR_ES['yearRangeFuture']}
                                        locale={CALENDAR_ES}
                                        showButtonBar={true}/>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default Sign;